import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=14a4b798&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=14a4b798&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a4b798",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ovilla/Documents/strappberry/catara-server/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14a4b798')) {
      api.createRecord('14a4b798', component.options)
    } else {
      api.reload('14a4b798', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=14a4b798&scoped=true", function () {
      api.rerender('14a4b798', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customer_dashboard/certificates/Index.vue"
export default component.exports